<section class="mt-4" aria-labelledby="notificationPermissionsTitle">
  <h3 id="notificationPermissionsTitle" class="m-0 mb-3 text-primary text-sm font-normal">
    {{ "role_management.notification_permissions.title" | translate }}
  </h3>

  <p-table class="mb-3 transparent" [value]="permissions()" [scrollable]="true" scrollHeight="300px">
    <ng-template #header>
      <tr>
        <th class="font-size-sm font-normal">
          {{ "role_management.notification_permissions.category" | translate }}
        </th>
        <th class="font-size-sm font-normal text-center w-7rem">
          {{ "role_management.notification_permissions.allowed" | translate }}
        </th>
      </tr>
    </ng-template>

    <ng-template #body let-permission>
      <tr [attr.data-category]="permission.category">
        <td>
          <label [for]="'notificationPermission-' + permission.category">
            {{ "notifications.notification_templates.categories." + permission.category | translate }}
          </label>
        </td>
        <td class="text-center w-7rem">
          <p-checkbox
            [inputId]="'notificationPermission-' + permission.category"
            [(ngModel)]="permission.match"
            [binary]="true"
            [disabled]="disabled()"
          />
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>
